import React from 'react';
import { Line } from 'rc-progress';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';


export const TimeDisplay = ({ elapsed, duration }) => {
    //Convert seconds value to x:yy format
    const parseTime = (time) => {
        if (isNaN(time)) {
            return "0:00";
        }
        const mins = Math.floor((time / 60)).toFixed(0);
        const secs = Math.floor((time % 60)).toFixed(0);
        return `${mins}:${secs < 10 ? "0" : ""}${secs}`;
    };

    return (
        <div className="SongTime">
            <h5 style={{margin: '0'}}>{parseTime(elapsed)} | {parseTime(duration)}</h5>
        </div>
    );
};

export const AuxControls = ({ onComplete, volume }) => {
    return (
        <div style={{
            display: "flex",
            alignItems: "center",
        }}>
            <i
                id="volume"
                className="fa fa-volume"
                style={{
                    color: '#fff',
                    marginRight: '1vw',
                    fontSize: '1.1em'
                }}
                alt="volume"
            />
            <VolumeSlider onComplete={onComplete} volume={volume} />
        </div>
    );
};

export const VolumeSlider = ({ onComplete, volume }) => {
    const volSlider = React.useRef();

    return (
        <div className="VolSliderContainer">
            <RangeSlider
                ref={volSlider}
                className="VolSlider single-thumb"
                value={volume}
                orientation="horizontal"
                onInput={onComplete}
                onChange={onComplete}
                defaultValue={[0, 100]}
                rangeSlideDisabled={true}
                thumbsDisabled={[true, false]}
                
            />
        </div>
    );
};

export const TrackList = ({ data, songList, currentTrackIndex }) => {
    const [tracks, setTracks] = React.useState([]);
    const [songListState, setSongListState] = React.useState([]);

    React.useEffect(() => {
        setTracks(data);
        setSongListState(songList);
    }, [data, songList]);

    if (!data.tracks.isPlayable) {
        return null;
    }

    const explicitMsg = songList[currentTrackIndex]?.explicit ? ' (Explicit)' : '';
    return (
        <div className="SongInfo">
            <div id="title">{songList[currentTrackIndex]?.title}{explicitMsg}</div>
            <div id="artist">{songList[currentTrackIndex]?.artist}</div>
        </div>
    );
};

export const FavButton = ({ tracks, onClick, isFavorited }) => {
    return (
        tracks.isPlayable && (
            <div className="control-buttons" style={{ marginTop: '30px' }}>
                <i 
                    id="hifive" 
                    onClick={onClick} 
                    className={`player-icon fas fa-heart ${isFavorited ? 'active' : ''}`}
                />
            </div>
        )
    );
};

export const ProgressBar = React.forwardRef(({ seekEvent, elapsedTime, trackDuration }, ref) => {
    const progressPercent = trackDuration > 0 ? elapsedTime / trackDuration : 0;

    return (
        <div ref={ref} style={{width: "40vw"}}>
            <Line 
                onClick={seekEvent} 
                onMouseDown={seekEvent} 
                className="Elapsed" 
                percent={progressPercent * 100} 
                strokeWidth="4" 
                strokeColor="#6f3c8a" 
                trailColor="#808080" 
                strokeLinecap="butt" 
            />
        </div>
    );
}); 